<template>
  <div class="min-h-screen bg-gray-100">
    <header class="bg-white shadow">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div class="flex items-center">
          <router-link to="/" class="text-xl font-bold">
            {{ $t('app.name') }}
          </router-link>
        </div>
        
        <div class="flex items-center gap-4">
          <LanguageSwitcher />
          <!-- 其他导航项 -->
        </div>
      </div>
    </header>

    <main class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <slot />
    </main>
  </div>
</template>

<script setup>
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'
</script>
